import React from "react";
import { useTranslation } from "react-i18next";
import Badge from "../../../../../components/Badge";
import { ManagerStatement } from "../../../../../interfaces/managerStatement.interface";
import { extractDateFromDateTimeBySpace } from "../../../../../utils/methods";

interface AuditCardsProps {
  statement: ManagerStatement;
}

const AuditCards: React.FC<AuditCardsProps> = ({ statement }) => {
  const { t } = useTranslation();

  return (
    <div className="row g-4 mb-1">
      <div className="col-lg-3 col-md-6">
        <div className="card card-border-shadow-info mb-4">
          <div className="card-body px-4 py-4">
            <div className="d-flex align-items-center flex-nowrap">
              <div className="avatar me-4">
                <div className="avatar-initial bg-label-info rounded-3">
                  <i className="ri-file-add-line ri-22px"></i>
                </div>
              </div>
              <div className="card-info">
                <div className="d-flex align-items-center">
                  <h6 className="mb-0 me-2">{statement.creator?.name || '-'}</h6>
                </div>
                <p className="mb-0">{statement.created_at ? extractDateFromDateTimeBySpace(statement.created_at) : '-'}</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-center" style={{ position: 'absolute', top: 0, right: 0 }}>
            <Badge
              className="px-2 py-1 fw-medium fs-8"
              variant="info"
              style={{ borderRadius: '0px 10px 0px 10px' }}
              text={t("reconciliation.managerStatement.detail.pageTexts.detailsTab.auditCards.createdBy")}
            />
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6">
        <div className="card card-border-shadow-primary mb-4">
          <div className="card-body px-4 py-4">
            <div className="d-flex align-items-center flex-nowrap">
              <div className="avatar me-4">
                <div className="avatar-initial bg-label-primary rounded-3">
                  <i className="ri-pencil-line ri-22px"></i>
                </div>
              </div>
              <div className="card-primary">
                <div className="d-flex align-items-center">
                  <h6 className="mb-0 me-2">{statement.updater?.name || '-'}</h6>
                </div>
                <p className="mb-0">{statement.updated_at ? extractDateFromDateTimeBySpace(statement.updated_at) : '-'}</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-center" style={{ position: 'absolute', top: 0, right: 0 }}>
            <Badge
              className="px-2 py-1 fw-medium fs-8"
              variant="primary"
              style={{ borderRadius: '0px 10px 0px 10px' }}
              text={t("reconciliation.managerStatement.detail.pageTexts.detailsTab.auditCards.updatedBy")}
            />
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6">
        <div className="card card-border-shadow-success mb-4">
          <div className="card-body px-4 py-4">
            <div className="d-flex align-items-center flex-nowrap">
              <div className="avatar me-4">
                <div className="avatar-initial bg-label-success rounded-3">
                  <i className="ri-check-double-line ri-22px"></i>
                </div>
              </div>
              <div className="card-success">
                <div className="d-flex align-items-center">
                  <h6 className="mb-0 me-2">{statement.completedBy?.name || t("reconciliation.managerStatement.detail.pageTexts.detailsTab.auditCards.notCompletedYet")}</h6>
                </div>
                <p className="mb-0">{statement.completed_at ? extractDateFromDateTimeBySpace(statement.completed_at) : '-'}</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-center" style={{ position: 'absolute', top: 0, right: 0 }}>
            <Badge
              className="px-2 py-1 fw-medium fs-8"
              variant="success"
              style={{ borderRadius: '0px 10px 0px 10px' }}
              text={t("reconciliation.managerStatement.detail.pageTexts.detailsTab.auditCards.completedBy")}
            />
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6">
        <div className="card card-border-shadow-warning mb-4">
          <div className="card-body px-4 py-4">
            <div className="d-flex align-items-center flex-nowrap">
              <div className="avatar me-4">
                <div className="avatar-initial bg-label-warning rounded-3">
                  <i className="ri-money-dollar-circle-line ri-22px"></i>
                </div>
              </div>
              <div className="card-warning">
                <div className="d-flex align-items-center">
                  <h6 className="mb-0 me-2">{statement.paidBy?.name || t("reconciliation.managerStatement.detail.pageTexts.detailsTab.auditCards.notPaidYet")}</h6>
                </div>
                <p className="mb-0">{statement.paid_at ? extractDateFromDateTimeBySpace(statement.paid_at) : '-'}</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-center" style={{ position: 'absolute', top: 0, right: 0 }}>
            <Badge
              className="px-2 py-1 fw-medium fs-8"
              variant="warning"
              style={{ borderRadius: '0px 10px 0px 10px' }}
              text={t("reconciliation.managerStatement.detail.pageTexts.detailsTab.auditCards.paidBy")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditCards;
